module.exports = __webpack_public_path__ + "static/media/Corner_Before.f59aa94d.jpg";